import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import Selection from "components/Input/Selection/Selection";
import statusOptions from "utils/statusOptions/StatusOptions.jsx";
import s from "./ChangeContent.module.scss";

const ChangeContent = ({ handleInput, data }) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({
    status: "",
  });
  const [focus, setFocus] = useState({});

  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  const statusOnChange = (value) => {
    setInputData({ ...inputData, status: value });
    return value;
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <OutlinedText
          label={t( "page.analytics.referrer.performance.change.function.dialog.content.1" )}
          mandatory
          noErrorMessage
          defaultValue={data.company ? data.company : ""}
          onchangeFn={(e) => textInputOnchange(e, "company")}
          onfocusFn={() => textInputOnFocus("company")}
          onblurFn={() => textInputOnBlur("company")}
          sxParams={{ textFocus: focus.company }}
        />
      </div>

      <div>
        <OutlinedText
          label={t( "page.analytics.referrer.performance.change.function.dialog.content.2")}
          noErrorMessage
          defaultValue={data.contact ? data.contact : ""}
          onchangeFn={(e) => textInputOnchange(e, "contact")}
          onfocusFn={() => textInputOnFocus("contact")}
          onblurFn={() => textInputOnBlur("contact")}
          sxParams={{ textFocus: focus.contact }}
        />
      </div>

      <div>
        <OutlinedText
          label={t("page.analytics.referrer.performance.change.function.dialog.content.3", )}
          mandatory
          noErrorMessage
          defaultValue={data.email ? data.email : ""}
          onchangeFn={(e) => textInputOnchange(e, "email")}
          onfocusFn={() => textInputOnFocus("email")}
          onblurFn={() => textInputOnBlur("email")}
          sxParams={{ textFocus: focus.email }}
        />
      </div>

      <div>
        <Selection
          label={t("page.analytics.referrer.performance.change.function.dialog.content.4")}
          mandatory
          selectionValue={
            inputData.status ? inputData.status : data.status ? data.status : ""
          }
          noErrorMessage
          onchangeFn={(e) => textInputOnchange(e, "status", statusOnChange)}
          onfocusFn={() => textInputOnFocus("status")}
          onblurFn={() => textInputOnBlur("status")}
          options={statusOptions(["ACTIVE", "SUSPENDED"])}
          sxParams={{ selectionFocus: focus.status }}
        />
      </div>
    </div>
  );
};

export default React.memo(ChangeContent);
